import dayjs from 'dayjs';

import {
  PerformanceMetrics,
  PerformanceResultsNotification,
} from 'pages/Campaign/PerformanceResults/api/usePerformanceResultsNotification/usePerformanceResultsNotification';
import { getCampaignNotificationNumber } from 'pages/Campaign/PerformanceResults/utils/getCampaignNotificationNumber';

export const getPerformanceResultsNotificationNumber = (
  groupedCampaigns: Record<string, PerformanceResultsNotification[]>,
  revealedMetrics: Record<string, PerformanceMetrics[]>,
): number => {
  let notificationNumber = 0;

  Object.entries(groupedCampaigns).forEach(([chainId, groupCampaign]) => {
    const contractStartDate = groupCampaign[groupCampaign.length - 1].startDate;

    const isShowFirst30DaysOption = dayjs(contractStartDate).isAfter('20250531');

    const introductoryEndDate = dayjs(contractStartDate).add(40, 'days').format('YYYYMMDD');

    const isSelectedCampaignRevealed = dayjs().isAfter(introductoryEndDate);

    if (!isSelectedCampaignRevealed) {
      const elapsedDays = dayjs().diff(dayjs(contractStartDate), 'days');

      notificationNumber += getCampaignNotificationNumber(
        isShowFirst30DaysOption,
        elapsedDays,
        revealedMetrics[chainId],
      );
    }
  });
  return notificationNumber;
};
